import(/* webpackMode: "eager" */ "/vercel/path0/src/app/privacy&cookies/privacyPolicy/page.tsx");
